(function () {
  const animated = document.querySelectorAll(".animate-on-scroll");
  if (!animated.length) return;

  if (!("IntersectionObserver" in window)) {
    animated.forEach((el) => el.classList.add("in-view"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
  );

  animated.forEach((el) => observer.observe(el));
})();
